module.exports = {
  backend: {
    uri: process.env.REACT_APP_BACKEND_URI || "http://alb-storyjam-backend-495553203.us-east-1.elb.amazonaws.com"
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js